// ** React Imports
import { ReactNode } from 'react'

// ** MUI Imports
import { SvgIconProps } from '@mui/material'

interface UserIconProps {
  iconProps?: SvgIconProps
  icon: string | ReactNode
}

const UserIcon = (props: UserIconProps) => {
  // ** Props
  const { icon, iconProps } = props

  // ESM modül nesnesi (default export) veya doğrudan bileşen - [object Module] hatasını önle
  const IconTag = icon && typeof icon === 'object' && 'default' in icon ? (icon as { default: React.ElementType }).default : icon

  // Geçerli React bileşeni değilse (örn. [object Module]) render etme
  const isValidComponent = IconTag && (typeof IconTag === 'function' || (typeof IconTag === 'object' && (IconTag as any)?.$$typeof))
  if (!isValidComponent) {
    return null
  }

  let styles

  /* styles = {
    color: 'red',
    fontSize: '2rem'
  } */

  // @ts-ignore
  return <IconTag {...iconProps} style={{ ...styles }} />
}

export default UserIcon
